module.exports = __webpack_public_path__ + "img/flt_pt_cone_setsku.prt.8a68d4be.jpg";